import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { observer } from 'mobx-react'
import { autobind } from 'core-decorators'
import moment from 'moment'
import classNames from 'classnames'
import FormattedDateTime from '../../shared/components/FormattedDateTime'
import { IComment, IReviewModel, IScreenshots } from '../../models'
import ScreenshotOverlay from './modals/ScreenshotOverlay'

import './ReviewCenter.scss'


interface IReviewCenterSingleChat {
  chat: IComment,
  currentUser: string,
  reviewModel: IReviewModel
}

interface IState {
  showScreenshotModal: boolean,
  screenshot: IScreenshots|any
}

@observer
export default class ReviewCenterSingleChat extends Component <IReviewCenterSingleChat> {
  state: IState

  constructor(props) {
    super(props)
    this.state = {
      showScreenshotModal: false,
      screenshot: {}
    }
  }

  @autobind
  handleImageClick({ target }) {
    const screenshot = this.props.chat.screenshots.find(el => el.id === target.id * 1)

    this.setState({
      screenshot,
      showScreenshotModal: true
    })
  }

  @autobind
  handleImageSwap(direcion: string) {
    const { screenshots } = this.props.chat
    const location = screenshots.findIndex(el => el.id === this.state.screenshot.id)
    if (direcion === 'left' && location !== 0) {
      this.setState({
        screenshot: screenshots[location - 1]
      })
    }
    if (direcion === 'right' && location !== (screenshots.length - 1)) {
      this.setState({
        screenshot: screenshots[location + 1]
      })
    }
  }

  renderAction() {
    const { chat } = this.props
    switch (chat.action) {
      case 1:
        return(
          <FormattedMessage id="review-center.action.approved-displayed" />
        )
      case 2:
        return(
          <FormattedMessage id="review-center.action.review-displayed" />
        )
      case 3:
        // eslint-disable-next-line no-case-declarations
        const name = this.props.chat.target ? `: ${this.props.chat.target}` : ''
        return (
          <FormattedMessage
            id="review-center.action.invite-displayed"
            values={{
              name
            }}
          />)
      default:
        return null
    }
  }

  renderScreenshotModal() {
    const { screenshot } = this.state

    return (
      <ScreenshotOverlay
        screenshot={screenshot}
        handleImageSwap={this.handleImageSwap}
        handleClose={() => this.setState({
          showScreenshotModal: false,
          screenshot: {}
        })}
      />
    )
  }

  renderErrorBlock(chat) {

    return (
      <div
        className='rc-chat-block'
        key={chat.id}
      >
        <div className="rc-chat-block-error">
          <FormattedMessage id="review-center.chat.error" />
        </div>
      </div>
    )
  }

  render() {
    let { chat } = this.props
    // verifies that it's atleast existing, but might not be necessary in TS
    chat = chat || {} as any

    const activeUser = chat.name === this.props.currentUser

    if (chat.name === 'Unknown') {
      return this.renderErrorBlock(chat)
    }

    return (
      <div
        className={classNames('rc-chat-block', {activeUser})}
        key={chat.id}
      >
        <div className="rc-name">
          {chat.name}
        </div>
        <div className="rc-date">
          <FormattedDateTime value={moment(chat.createdAt)} />
          <FormattedMessage id="review-center.chat.hour" />
        </div>
        <div className="rc-text">

          {this.renderAction()}

          <div className="content" dangerouslySetInnerHTML={{__html: chat.text}}></div>

        </div>
        {
          chat.screenshots && chat.screenshots.map((screenshot) => {

            return (
              <img
                src={screenshot.thumbnailUrl}
                alt=""
                key={screenshot.id}
                id={`${screenshot.id}`}
                onClick={this.handleImageClick}
              />
            )
          })
        }

        {this.state.showScreenshotModal
          ? this.renderScreenshotModal()
          : null}

      </div>
    )
  }
}
